import {StatusBar} from "expo-status-bar";
import {useColorModeValue} from "native-base";

export const StatusBarStyled = () => {
    return (
        <StatusBar style={useColorModeValue('dark', 'light')}/>
    )
}